import { whyChooseUs } from "./constants";
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { MOTION_OK, revealTrigger, riseFrom } from "../../utils/animations";

export function WhyChoseAI() {
  const sectionRef = useRef(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        riseFrom(".why-head > *", {
          stagger: 0.15,
          scrollTrigger: revealTrigger(".why-head"),
        });
        riseFrom(".why-card", {
          y: 56,
          duration: 1,
          stagger: 0.12,
          scrollTrigger: revealTrigger(".why-grid", "top 75%"),
        });
      });
      return () => mm.revert();
    },
    { scope: sectionRef }
  );

  return (
    <section ref={sectionRef} className="bg-[#EDF1FF] py-[48px]">
      <div className="container space-y-12">
        <div className="why-head">
          <h2 className="text-[#020128] font-extrabold text-[24px] md:text-[32px] text-center">
            Why Choose Us
          </h2>
          <p className="text-[#020128] text-sm md:text-base text-center">
            A vertically integrated stack, from silicon to agent.
          </p>
        </div>

        <div className="why-grid grid grid-cols-12 gap-8">
          {whyChooseUs.map((item, idx) => (
            <div key={idx} className="why-card group col-span-12 md:col-span-6 bg-white hover:bg-poppingBlue flex flex-col md:flex-row items-center md:items-start rounded-xl p-6 md:p-8 gap-4 transition-colors duration-700">
              <img src={item.img} alt={`${item.title} illustration`} className="w-16 h-16 transition-all duration-700 group-hover:brightness-0 group-hover:invert" />
              <div className="space-y-2 text-center md:text-start">
                <h5 className="text-base md:text-xl font-bold text-[#020128] transition-colors duration-700 group-hover:text-white">{item.title}</h5>
                <p className="text-sm md:text-base text-[#020128] transition-colors duration-700 group-hover:text-white">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
